module.exports = __webpack_public_path__ + "img/ico_join.a4602bf5.svg";